"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.ToolbarItem = ({ image, text, showText = true, showButton = true, onClick, buttonClassName, }) => {
    const className = classnames_1.default("toolbar-item", buttonClassName, {
        hidden: !showButton,
    });
    return (react_1.default.createElement("button", { onClick: onClick, className: className },
        image,
        react_1.default.createElement("span", { className: classnames_1.default({ display: showText }) }, text)));
};
//# sourceMappingURL=toolbar-item.js.map